import { useState } from "react";
import { motion } from "framer-motion";
import { CalendarHeart, Gift, Mail, ShoppingCart, SplitSquareHorizontal } from "lucide-react";
import { useCart } from "../lib/store";
import { PageHead } from "./Shop";
import { VoucherCard } from "../components/VoucherCard";
import { useSeo } from "../components/Seo";

const VALUES = [100, 200, 300, 500, 1000];
const INFO = [
  [Mail, "Kód přijde e-mailem", "Hned po zaplacení vám pošleme jedinečný kód poukazu."],
  [CalendarHeart, "Platí 12 měsíců", "Poukaz lze uplatnit kdykoli během roku od nákupu."],
  [SplitSquareHorizontal, "Čerpání postupně", "Nevyužitý zůstatek zůstává na kódu pro další nákup."],
  [Gift, "Kombinace se slevou", "Poukaz jde použít spolu se slevovým kódem."],
];

export default function GiftVouchers() {
  useSeo({ title: "Dárkové poukazy", description: "Darujte radost z učení – dárkový poukaz na hravé materiály v hodnotě 100 až 1000 Kč." });
  const { add } = useCart();
  const [value, setValue] = useState(500);
  const buy = () => add({ id: `gift-${value}`, name: `Dárkový poukaz ${value} Kč`, slug: "darkove-poukazy", price: value, images: ["/voucher-thumb.svg"] });
  return (
    <div data-testid="gift-vouchers-page">
      <PageHead title="Dárkové poukazy" sub="Darujte radost z učení. Obdarovaný si sám vybere materiály, které jeho dítěti udělají největší radost." />
      <div className="mx-auto grid max-w-7xl items-center gap-10 px-4 py-12 sm:px-8 lg:grid-cols-[1.25fr_1fr]">
        <motion.div key={value} initial={{ opacity: 0, rotate: -2, y: 16 }} animate={{ opacity: 1, rotate: 0, y: 0 }} transition={{ type: "spring", damping: 16 }}>
          <VoucherCard value={value} testid="gift-preview" />
        </motion.div>
        <div className="space-y-6">
          <div>
            <p className="font-script text-2xl text-[#D96B43]">Vyberte hodnotu</p>
            <div className="mt-3 flex flex-wrap gap-2">
              {VALUES.map((v) => (
                <button key={v} onClick={() => setValue(v)} data-testid={`gift-value-${v}`}
                  className={`rounded-full border-2 px-5 py-3 font-serif text-lg font-black italic transition-colors ${value === v ? "border-[#7A8460] bg-[#7A8460] text-white" : "border-[#E2DACB] bg-white hover:border-[#A3AC86]"}`}>
                  {v} Kč
                </button>
              ))}
            </div>
          </div>
          <button onClick={buy} className="btn-sage w-full !py-4 sm:w-auto" data-testid="gift-add-to-cart"><ShoppingCart className="h-4 w-4" /> Přidat poukaz do košíku</button>
          <div className="grid gap-3 sm:grid-cols-2">
            {INFO.map(([I, t, d]) => (
              <div key={t} className="card-soft flex gap-3 p-4">
                <span className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-[#E9EFE0] text-[#7A8460]"><I className="h-5 w-5" /></span>
                <div><p className="text-sm font-semibold">{t}</p><p className="text-xs text-[#6E7565]">{d}</p></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
